<template>
  <div
    class="ds-form-caption"
    :class="{ 'ds-form-caption--invalid': isOfInvalidType }"
  >
    <template v-if="isOfInvalidType">
      <AlertCircle />
      <div>
        <slot />
      </div>
    </template>
    <slot v-else />
  </div>
</template>

<script>
import AlertCircle from '@tagvenue/icons/24/bold/alerts-feedback/alert-circle.svg';

export default {
  name: 'FormCaption',
  components: {
    AlertCircle,
  },
  props: {
    type: {
      type: String,
      validator(type) {
        return ['invalid', 'info'].indexOf(type) !== -1;
      },
      default: 'info',
    },
  },
  computed: {
    isOfInvalidType() {
      return this.type === 'invalid';
    },
  },
};
</script>
